import { pageViewTypes } from "@constants/tracking";
import { emptyStates } from "@features/dashboard/constants";
import useAnalytics from "@hooks/useAnalytics";
import Box from "@memorang/ui/components/Box";
import OverallYourStreakCard from "@memorang/ui/components/Cards/OverallStreakCard";
import OverallYourAchievementsCard from "@memorang/ui/components/Cards/OverallYourAchievementsCard";
import OverallYourGuessDistributionCard from "@memorang/ui/components/Cards/OverallYourGuessDistributionCard";
import OverallYourProgressCard from "@memorang/ui/components/Cards/OverallYourProgressCard";
import StrengthsAndWeaknessCard from "@memorang/ui/components/Cards/StrengthsAndWeaknessCard";
import EmptyState from "@memorang/ui/components/EmptyView";
import Loader from "@memorang/ui/components/Loader";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { router } from "expo-router";
import { useMemo } from "react";
import { ProgressEmptySvg } from "../../../../../assets";
import { useInsights } from "../../hooks/useInsights";
const ProgressView = () => {
	const eventsObject = useMemo(() => {
		return {
			type: pageViewTypes.progress,
		};
	}, []);
	useAnalytics(eventsObject);
	const {
		overallProgressData,
		// overallRankData,
		overallAchievementsData,
		overallGuessDistributionData,
		overallStreakData,
		strengthsAndWeaknessData,
		isLoading,
		showEmptyState,
	} = useInsights();

	if (showEmptyState) {
		return (
			<EmptyState
				{...emptyStates.insights}
				cta="START CHALLENGE"
				image={ProgressEmptySvg}
				handleAction={() => {
					router.push("/home");
				}}
			/>
		);
	}

	return (
		<>
			<ScrollContainer maxWidth="sm">
				{isLoading ? (
					<Box
						flexGrow={1}
						justifyContent="center"
						alignItems="center"
						height="100%"
					>
						<Loader />
					</Box>
				) : (
					<Box padding={16} gap={16}>
						<OverallYourProgressCard {...overallProgressData} />
						{strengthsAndWeaknessData && (
							<StrengthsAndWeaknessCard {...strengthsAndWeaknessData} />
						)}
						{/* <OverallYourRankCard {...overallRankData} /> */}
						<OverallYourAchievementsCard {...overallAchievementsData} />
						<OverallYourGuessDistributionCard
							{...overallGuessDistributionData}
						/>
						<OverallYourStreakCard {...overallStreakData} />
					</Box>
				)}
			</ScrollContainer>
		</>
	);
};

export default ProgressView;
